import { walletPay } from '@web-publish-id/wallet-pay'
import { PaymentOrderInfo } from '../apis/types/payment'
import { PAYMENT_APP_VERSION } from '../const'
import { PublishPaymentMethodItem } from '../apis/types/payment'
import { createPaymentDropinOrder } from '../apis/payment'
import { errorToJson } from '@web-publish-id/shared/utils/error'
import { isPaymentRetryError } from '../utils/paymentRetry'

/*
  @description: 创建钱包支付dropin
  @param {Object} config
  @param {Object} handles
  @returns {Object}
*/
export const createWalletDropin = (config: {
  token: string
  clientId: string
  language: string
  orderInfo: PaymentOrderInfo
  sdkVersion?: string

  onSubmit?: () => void
  onError?: (error: any) => void
  onLoaded?: () => void
  onCreateOrder?: (result: any) => void
  onCompleted?: (result: any) => void
  onFailed?: (result: any) => void
  onLoading?: (loading: boolean) => void
}) => {
  const { token, clientId, language, orderInfo, sdkVersion = PAYMENT_APP_VERSION } = config

  let paymentMethod: PublishPaymentMethodItem

  walletPay.init({
    price: orderInfo.mark_price,
    orderInfo,
    token,
    clientId,
    language,
    onSubmit: () => {
      config.onSubmit?.()
    },
    onValidated: async (data) => {
      config.onLoading?.(true)
      try {
        if (data.err) throw data

        const result = await createPaymentDropinOrder({
          dropin_channel_data: JSON.stringify(data),
          payment_channel_type: 5,
          payment_method_id: paymentMethod.payment_method_id,
          sys_order_id: orderInfo.sys_order_id,
          sdk_version: sdkVersion,
          os: 1,
        })

        config.onCreateOrder?.(result)

        config.onCompleted?.(result)
      } catch (error) {
        config.onFailed?.(isPaymentRetryError(error) ? error : errorToJson(error))
      } finally {
        config.onLoading?.(false)
      }
    },
    onError: (e) => {
      config.onError?.(e)
    },
    onLoaded: () => {
      config.onLoaded?.()
    },
  })

  // 设置支付方式
  const setup = async (containerId: string, _paymentMethod: PublishPaymentMethodItem) => {
    paymentMethod = _paymentMethod
    return walletPay.setupPage(containerId)
  }

  return {
    setup,
  }
}
